import LocalizationStore from "LocalizationStore";
import PortalContainer from 'PortalContainer';
import PropTypes from 'prop-types';
import StringUtil from "StringUtil";
import TimeTrackingWindow from "TimeTrackingWindow";
import UserInfoUtil from "UserInfoUtil";
import BaseServiceApi from "BaseServiceApi";
import React, { Component } from "react";
import { AllowedFinancialMetricIds } from "../../../../../Constants/AINewsConstants.js";
import { connect } from 'react-redux';
import { fetchFinancialBlockMetricsData, setPopupConfig, setTriggerClose } from "../../../../../Actions/AINewsActions.js";
import DataRowCell from "./DataRowCell.jsx";

const EntitlementType = BaseServiceApi.rayData["EntitlementType"];
class DataRow extends Component {
  constructor(props) {
    super(props);
    this.state = {
      row: props.row,
      rowHeight: props.rowHeight,
      nodeWidth: props.nodeWidth,
      width: props.width,
      hover: false,
      isAIEnabled:
        props.applicableFinancialBlockMetricsData.includes(props.SymTypeEnum)
        && UserInfoUtil.IsUserEntitled(EntitlementType.AI_FINANCIAL_BLOCK_Entitlement)
        && Object.values(AllowedFinancialMetricIds).some(
          (metric) => metric.headerId === props.row.Row.Header.HeaderId
        ), 
      selectedIndex: -1,
      hoverCellIndex: -1,
      isMiniListOpen: props.isMiniListOpen
    };
  }

  handleCellClick(cellIndex, metricsName) {
    const target = document.getElementById(`financial_cell_${metricsName}_${cellIndex}_${this.props.row?.index}`);
    const textRect = target.getBoundingClientRect();
    const windowWidth = window.innerWidth;
    const rightSpace = windowWidth - textRect.right;
    const isEnoughSpaceOnTop = textRect.top > 300;
    let transformX = isEnoughSpaceOnTop ? "-46px" : "-85px";
    if(rightSpace < 57) {
        transformX = (rightSpace + 5)+"px";
    } else if (textRect.width > 150) {
      transformX = isEnoughSpaceOnTop ? (this.state.isMiniListOpen ? "58px" : "35px"): "10px";
    }
    this.props.setTriggerClose(false);
    this.props.fetchFinancialBlockMetricsData(metricsName, this.state.row.cellItems[cellIndex].date);
    this.props.setPopupConfig(true, { target: target, transform: `${transformX}, ${isEnoughSpaceOnTop ? '-10px' : '10px'}`, metricsName: metricsName, date: this.state.row.cellItems[cellIndex].date, placement: isEnoughSpaceOnTop ? "top" : "bottom" });
    this.setState({ selectedIndex: cellIndex });
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (nextProps.width !== undefined) {
      this.setState({ width: nextProps.width });
    }
    if (nextProps.row !== undefined) {
      this.setState({ row: nextProps.row, dogEar: undefined });
    }
    if (nextProps.showAIPopup === false) {
      this.setState({ selectedIndex: -1 })
    }
    if (nextProps.SymTypeEnum) {
      const isAIEnabled =
        nextProps.applicableFinancialBlockMetricsData.includes(nextProps.SymTypeEnum)
        && UserInfoUtil.IsUserEntitled(EntitlementType.AI_FINANCIAL_BLOCK_Entitlement)
        && Object.values(AllowedFinancialMetricIds).some(
          (metric) => metric.headerId === nextProps.row.Row.Header.HeaderId
        )
      this.setState({ isAIEnabled: isAIEnabled })
    }
    this.setState({ isMiniListOpen: nextProps.isMiniListOpen })
  }
  
  getCellValues() {
    const row = this.state.row;
    if (
      row === undefined ||
      row === null ||
      this.state === undefined ||
      this.state.width === 0.0
    ) {
      return null;
    }
    const cells = [];
    const width = this.state.width;
    const cellItems = row.cellItems;
    const length = cellItems.length;
    const metricsName = Object.values(AllowedFinancialMetricIds).find(
      (item) => item.headerId === row.Row.Header.HeaderId
    )?.name;
    for (let cellIndex = 0; cellIndex < length; cellIndex++) {
      const cellItem = cellItems[cellIndex];
      const xAxis = width - cellItem.XPoint * this.state.nodeWidth - 3;
      if (xAxis < 0) continue;

      const nextCell = cellItems[cellIndex + 1];
      const nextXAxis = nextCell ? width - nextCell.XPoint * this.state.nodeWidth : width;
      const xpoint = nextXAxis + 1;
      const cWidth = xAxis - nextXAxis + 3;

      const dogEarText = cellItem.DogEarContent
        ? this.CarryOverTextTranslation(cellItem.DogEarContent)
        : "";

      cells.push(
        <DataRowCell
          key={cellIndex}
          cellItem={cellItem}
          cellIndex={cellIndex}
          metricsName={metricsName}
          xAxis={xAxis}
          xpoint={xpoint}
          cWidth={cWidth}
          rowHeight={this.state.rowHeight}
          isSelected={this.state.selectedIndex === cellIndex}
          isAIEnabled={this.state.isAIEnabled}
          handleCellClick={(cellIndex, metricsName) => this.handleCellClick(cellIndex, metricsName)}
          dogEarText={dogEarText}
          rowIndex={this.props.row?.index}
          showDogEar={(dogEarObj) => this.showDogEar(dogEarObj)}
          isWithIndex={cellIndex + 1 < cellItems.length}
        />
      );
    }
    return cells;
  }

  CarryOverTextTranslation(DogEarContent) {
    if (UserInfoUtil.getCurrentLangCode() === "zh-cn") {
      let carryOverText = "";
      const contents = DogEarContent.split('\n');
      for (let i = 0; i < contents.length; i++) {
        const content = contents[i];
        if (StringUtil.isEmpty(content)) { continue; }
        if (i > 1) {
          carryOverText += `\n \n${this.DogEarContentTranslation(content)}`;
        } else {
          carryOverText += this.DogEarContentTranslation(content);
        }
      }
      return carryOverText;
    } else {
      return DogEarContent;
    }
  }

  DogEarContentTranslation(content) {
    const dogEarContentTranslateObj = {
      ["Pretax non-reoccurring items are included"]: LocalizationStore.getTranslatedData("fb_hoverpretax", content),
      ["Calculation based on a negative number in the latest period or same quarter of previous year"]: LocalizationStore.getTranslatedData("fb_hover", content),
      ["Indicates Semi-Annual Data"]: LocalizationStore.getTranslatedData("fb_indicates_1", content), ["Indicates Annual Data"]:
        LocalizationStore.getTranslatedData("fb_indicates_2", content)
    }
    const dogEarContent = dogEarContentTranslateObj[content] ? dogEarContentTranslateObj[content] : content;
    return dogEarContent;
  }


  onHover(hover) {
    this.setState({ hover: hover });
  }

  syncHover(index, hover) {
    this.props.syncHover(index, hover);
  }
  reDraw() {
    this.setState({});
  }
  showDogEar(dogEarObj) {
    this.setState({ dogEar: dogEarObj });
  }

  getDogEarContent() {
    const deContentText = this.state.dogEar.text.length < 30 ? "deContent deContent-Singleline" : "deContent";
    return (
      <PortalContainer>
        <div className="dogEarMain financial-dogear" style={{ left: window.event.clientX, bottom: window.innerHeight - window.event.clientY }}>
          <div className="deBorder">
            <div className={deContentText}>
              {this.state.dogEar.text}
            </div>
          </div>
        </div>
      </PortalContainer>
    )
    // return (<div className="dogEarMain" style={{ left: this.state.dogEar.x }}>
    //   <div className="deBorder">
    //     <div className="deContent">
    //       {this.state.dogEar.text}
    //     </div>
    //   </div>
    // </div>);
  }

  render() {
    const cells = this.getCellValues();
    TimeTrackingWindow.trackChartLoadingTime();
    const clsHover = this.state.hover ? "financial-block-row hover-on-row borderBottom" : "financial-block-row ";
    return (
      <div className="financial-block-row"
        style={{ height: this.state.rowHeight }}
        onMouseOver={() => this.syncHover(this.state.row.index, true)}
        onFocus={() => this.syncHover(this.state.row.index, true)}
        onMouseLeave={() => this.syncHover(this.state.row.index, false)}>
        <div className={clsHover} style={{ height: this.state.rowHeight + 1 }}></div>
        <svg className="financial-block-row-item" id="row">{cells}</svg>
        {this.state.dogEar && this.getDogEarContent()}
      </div>
    );
  }
}
DataRow.propTypes = {
  row: PropTypes.object.isRequired,
  rowHeight: PropTypes.number.isRequired,
  nodeWidth: PropTypes.number.isRequired,
  width: PropTypes.number.isRequired,
  syncHover: PropTypes.func.isRequired
};

const mapStateToProps = (state) => {
  const { financialBlockMetricsData, showAIPopup, applicableFinancialBlockMetricsData } = state.aiNewsReducer;
  const { TimeLineLabels } = state.DatagraphReducers.TimeLineReducer;
  const { SymTypeEnum, isMiniListOpen } = state.DatagraphReducers.DataGraphReducer;

  return { financialBlockMetricsData, TimeLineLabels, showAIPopup, applicableFinancialBlockMetricsData, SymTypeEnum, isMiniListOpen }
}

const mapDispatchToProps = (dispatch) => ({	
  fetchFinancialBlockMetricsData: (metrics, date) => dispatch(fetchFinancialBlockMetricsData(metrics, date)),
  setPopupConfig: (showAIPopup, popupConfig) => dispatch(setPopupConfig(showAIPopup, popupConfig)),
  setTriggerClose: (triggerClose) => dispatch(setTriggerClose(triggerClose))
  
})

export default connect(mapStateToProps, mapDispatchToProps, null, { forwardRef: true })(DataRow)
